export default __webpack_public_path__ + "static/media/No_coupon_avalaible.92ff75db.svg";